export enum EligibilityCodes {
    PRE_APPROVED = 1,
    PRE_QUALIFIED = 2,
    NEEDS_INSPECTION = 3,
    REJECTED = 4,
}
